import { defineMigrations } from "@supersig/store";
/** @public */ export const stackNodeProps = {};
/** @internal */ export const stackNodeMigrations = defineMigrations({});
export const StackNodeInfo = {
    migrations: stackNodeMigrations,
    props: stackNodeProps,
    meta: {}
};
